import { isDiscordActivity } from "@bn-games/discord-activity";

// The Capacitor global is only injected by a native iOS/Android shell — same
// zero-dependency proxy for "embedded shell" as MenuCorners.ts, and duplicated
// from it for the same reason it duplicates apps/sudoku's copy: five lines with
// no dependency worth wiring a module around.
function isCapacitorNative(): boolean {
  return (
    typeof window !== "undefined" &&
    Boolean((window as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor?.isNativePlatform?.())
  );
}

/**
 * True inside a Discord Activity or a Capacitor native shell. Accepting an
 * invite navigates out to another game's URL, which breaks an embedded
 * activity and is not what a native app binary should do either — so the
 * social surfaces render nothing there.
 */
export function isEmbeddedShell(): boolean {
  return isDiscordActivity() || isCapacitorNative();
}
